import useAppStore from "../stores/AppStore"
import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
            // return 'Sem Internet ou sistema fora do ar!'
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

/*
    Para abrir um caixa, você precisa enviar um JSON
    {
        idEstabelecimento: 92348923,
        nomeEstabelecimento: 'Apresentacao', 
        nomeAbertura: 'Marco',
        observacao: 'Estou com dificuldades hoje.'
        dinheiroInicial: 30.0,
        idUsuarioAbriu: 823974,
        tipo: [
            {
                id: 'DELIVERY_ONLINE',
            },
            {
                id: 'RETIRADA_ONLINE',
            },
        ],
    }

    e você recebera um json de resposta

    sucesso: status request entre 200 e 299
    falha: status >= 300 
    retorno será {status: 401, mensagem: ‘algo deu errado’}
*/
export const abrirCaixa = function (caixaRecebido, basicUsuario) {
    return {
        id: 1,
        idEstabelecimento: caixaRecebido.idEstabelecimento,
        nomeEstabelecimento: caixaRecebido.nomeEstabelecimento,
        abertoEm: new Date(),
        fechadoEm: null,
        nomeAbertura: caixaRecebido.nomeAbertura,
        dinheiroInicial: caixaRecebido.dinheiroInicial,
        idUsuarioAbriu: caixaRecebido.idUsuarioAbriu,
        statusFuncionamento: 1, //aberto(1), fechado(0),

        pedidosDoCaixa: [],

        tipo: caixaRecebido.tipo,

        pagamentos: [],

        retiradasDoCaixa: [],

        somaVenda: 0.0,
        somaVendaDinheiro: 0.0,
        somaRetiradasDoCaixa: 0.0,
        somaDinheiroEmCaixa: 0.0,
        somaQuebraDePedidos: 0.0,

        quantidadeEntregadoresAssociados: 0,
        quantidadePedidos: 0,
        quantidadeRetiradasDoCaixa: 0,
    }
}

/*
    Para fechar um caixa, você precisa enviar um JSON
    {
        idCaixa: 92348923,
        observacao: 'eu e marco ficou por conta do caixa hoje'
    }

    e você recebera um json de resposta

    sucesso: status request entre 200 e 299
    falha: status >= 300 
    retorno será {status: 401, mensagem: ‘algo deu errado’}
*/
export const fecharCaixa = function (data, basicUsuario) {
    return {
        status: 200,
        mensagem: "Caixa fechado com sucesso!",
    }
}

/*
    Para buscar notas fiscais
    você precisa apenas mandar um json com os filtros selecionados

    filtro = {
        statusNotaFiscal: 'em processo',
        de: 12/03/2021,
        ate: 15/03/2021,
        idPedido: 583475,
        nomePedido: 'Larissa',
    }
    
    (filtro, basic do usuario) 
    
    e você vai receber a informação de todas as notas fiscais do filtro

    sucesso: status request entre 200 e 299
    falha: status >= 300 
    retorno será {status: 401, mensagem: ‘algo deu errado’}
*/
export const buscarNotasFiscais = function (data, basicUsuario) {
    return [
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "não processado",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Larissa",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "iOS",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "em processo",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Larissa",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "iOS",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "em processo",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Joao",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "Site",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "processado",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Marco",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "iOS",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "em processo",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Larissa",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "Site",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "não processado",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Paulo",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "Android",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "não processado",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Pablo",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "Site",
        },
        {
            id: 13234,
            dataStatus: "12/12/2012",
            statusNotaFiscal: "processado",

            idEstabelecimento: 2203,
            idPedido: 583475,
            nomePedido: "Amanda",
            dataPedido: "12/12/2012",
            valorPedido: 50.0,
            plataformaPedido: "Android",
        },
    ]
}

/*
    Para emitir a nota fiscal, vc deve enviar
    
    (idNotaFiscal, basic do usuario) 
    
    e você vai receber se foi aprovado e o novo status da nota

    sucesso: status request entre 200 e 299
    falha: status >= 300 
    retorno será {status: 401, mensagem: ‘algo deu errado’}
*/


export const resumodiaentregadores = async function (data) {
    try {
        const response = await api
            .get("integracao/entregadores/resumodia", {
                headers: { "Content-Type": "application/json", Authorization: data },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "resumodiaentregadores")
    } catch (error) {
        RegistrarLogErro(error, "resumodia", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ResumoDia = async Authorization => {
    try {
        const response = await api.get("/integracao/geral/resumodia", {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })

        return tratamentoResponse(response, "ResumoDia")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "ResumoDia", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const Parametros = async function (Authorization) {
    try {
        const response = await api.post(
            "integracao/parametros",
            {},
            {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            }
        )


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "Parametros")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const parametrosId = async (idEstabelecimento, Authorization) => {
    const url = `/integracao/parametrosestabelecimento?idEstabelecimento=${idEstabelecimento}`

    try {
        const response = await api.post(
            url,
            {},
            {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            }
        )

        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "parametrosId")
        console.error(error)
        return { retornoErro: 1, mensagem: error.message }
    }
}

/**
 * REDE DE SEGURANÇA de impressão: lista o que ainda não foi impresso, SEM dar ACK.
 *
 * NÃO existe mais um par EventsPolling/acknowledgmentsingle aqui, e isso é proposital.
 * O `/eventspolling` só entrega o evento uma vez: o ACK move a SolicitacaoImpressao para
 * impressa e ela some da fila que os ePDVs drenam — o painel roubaria o evento do PDV da
 * loja. Este endpoint é somente leitura, então as integrações seguem intactas e a
 * proteção contra imprimir duas vezes é o dedup por id no cliente.
 *
 * Devolve sempre um array: quem chama é a rede de segurança e não deve precisar
 * distinguir "deu erro" de "não tem nada".
 */
export const impressoesPendentes = async function (Authorization) {
    try {
        const response = await api.get("integracao/impressoes/pendentes", {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })

        return Array.isArray(response.data) ? response.data : []
    } catch (error) {
        RegistrarLogErro(error, "impressoesPendentes")
        console.error(error)
        return []
    }
}

export const atualizarUsuarioBasico = async function (Authorization, data) {
    try {
        const response = await api.post(
            `/integracao/atualizarUsuario/${data.idUsuario}/${data.novoNome}/${data.novoTelefone}`,
            {},
            {
                headers: { "Content-Type": "application/json", authorization: Authorization },
            }
        )


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "atualizarUsuarioBasico", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}
export const inserirPedidoMesa = async function (Authorization, pedido) {
    try {
        const response = await api.post(
            `integracao/inserirpedidomesa/${pedido.id}/${pedido.mesa}`,
            {},
            {
                headers: { "Content-Type": "application/json", authorization: Authorization },
            }
        )


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "inserirPedidoMesa", pedido)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const atualizarTempoEntrega = async function (Authorization, data) {
    try {
        const response = await api.post(`integracao/atualizartempodeentrega`, data, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "atualizarTempoEntrega", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}
export const atualizarStatus = async function (Authorization, data) {
    try {
        const response = await api.post(
            `integracao/atualizarsituacao/${data.idEstabelecimento}/${data.situacao}`,
            {},
            {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            }
        )


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "ParametrosatualizarStatus", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const buscarInformacoesPedido = async function (Authorization, id) {
    try {
        const response = await api
            .get(`integracao/orders/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "buscarInformacoesPedido")
    } catch (error) {
        RegistrarLogErro(error, "buscarInformacoesPedido", id)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Histórico de um pedido (ações/troca de status). Consulta sob demanda ao clicar no pedido.
// Endpoint REST já existente no sistemaadm: GET /pedido/historico/{idPedido} -> List<HistoricoPedido>
export const buscarHistoricoPedido = async function (idPedido, Authorization) {
    try {
        const response = await api.get(`pedido/historico/${idPedido}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })
        const historico = Array.isArray(response.data) ? response.data : response.data?.historico || []
        return { retornoErro: 0, historico }
    } catch (error) {
        const mensagem =
            error?.response?.data?.mensagem || error?.response?.data?.message || error.message
        RegistrarLogErro(error, "buscarHistoricoPedido", idPedido)
        return { retornoErro: 1, mensagem, historico: [] }
    }
}

export const buscarInformacoesMesa = async function (Authorization, id) {
    try {
        const response = await api
            .get(`integracao/buscarmesa/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "buscarInformacoesPedido")
    } catch (error) {
        RegistrarLogErro(error, "buscarInformacoesPedido", id)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Busca uma mesa (ControleMesa) por id já com pedidosMesa enriquecido, para o Gerenciador de
// Mesas abrir uma sessão exata (aberta ou fechada). Endpoint dedicado, não mexe no buscarmesa.
export const buscarMesaComPedidos = async function (Authorization, id) {
    try {
        const response = await api
            .get(`integracao/buscarmesacompedidos/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "buscarMesaComPedidos")
    } catch (error) {
        RegistrarLogErro(error, "buscarMesaComPedidos", id)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const buscarestabelecimentos = async function (Authorization) {
    try {
        const response = await api.get("integracao/buscarestabelecimentos", {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarEstabelecimentos")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const fecharmesa = async function (Authorization, data) {
    try {
        const response = await api.post(
            `integracao/fecharmesa/${data.numeroMesa}`,
            {},
            {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            }
        )


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "fecharMesa", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}
export const buscarMesas = async function (estabelecimentoId, Authorization) {
    try {
        const response = await api.get(`integracao/buscarmesas/${estabelecimentoId}`, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarMesas")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ObterStatusLojaIfood = async function (estabelecimento, Authorization) {
    try {
        const response = await api
            .post(`ifood/merchant/status`, estabelecimento, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "statusLojaIfood")
    } catch (error) {
        RegistrarLogErro(error, "statusLojaIfood", estabelecimento)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export async function buscarCidades({ q, uf, limit }, basicUsuario) {
    try {
        const params = new URLSearchParams()
        if (q) params.append("q", q)
        if (uf) params.append("uf", uf)
        if (limit) params.append("limit", String(limit))
        const qs = params.toString()
        const url = `integracao/cidades${qs ? `?${qs}` : ""}`
        const response = await api.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: basicUsuario,
            },
        })
        return { retornoErro: 0, cidades: Array.isArray(response.data) ? response.data : [] }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const mensagem =
            data?.mensagem || data?.message || error.message || "Erro ao buscar cidades."
        RegistrarLogErro(error, "buscarCidades", { q, uf, limit })
        return { retornoErro: 1, mensagem, status, cidades: [] }
    }
}

// Autocadastro público de restaurante (self-onboarding). Endpoint público — sem
// Authorization. Cria estabelecimento + assinatura + 1ª fatura (aberta) e envia
// credenciais por e-mail; retorna login/senha + dados da fatura (urlIugu).
export async function onboardingRestaurante(body) {
    try {
        const response = await api.post("clientefiel/OnboardingRestaurante", body, {
            headers: { "Content-Type": "application/json" },
        })
        const data = response.data || {}
        if (data.codErro && data.codErro > 0) {
            return { retornoErro: data.codErro, mensagem: data.mensagem, data }
        }
        return { retornoErro: 0, data }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const mensagem =
            data?.mensagem || data?.message || error.message || "Não foi possível concluir o cadastro."
        RegistrarLogErro(error, "onboardingRestaurante", { email: body?.emailLoja })
        return { retornoErro: 1, mensagem, status }
    }
}

// Salva um cadastro parcial (rascunho) e retorna um token. O vendedor gera o link e
// envia ao dono do restaurante finalizar. Público — sem Authorization.
export async function salvarRascunhoOnboarding(body) {
    try {
        const response = await api.post("clientefiel/SalvarRascunhoOnboarding", body, {
            headers: { "Content-Type": "application/json" },
        })
        const data = response.data || {}
        if (data.codErro && data.codErro > 0) {
            return { retornoErro: data.codErro, mensagem: data.mensagem }
        }
        return { retornoErro: 0, token: data.token }
    } catch (error) {
        const mensagem =
            error?.response?.data?.mensagem || error.message || "Não foi possível salvar o rascunho."
        RegistrarLogErro(error, "salvarRascunhoOnboarding", {})
        return { retornoErro: 1, mensagem }
    }
}

// Recupera um rascunho de onboarding pelo token (link enviado ao dono do restaurante).
export async function obterRascunhoOnboarding(token) {
    try {
        const response = await api.get(`clientefiel/RascunhoOnboarding/${encodeURIComponent(token)}`)
        return { retornoErro: 0, data: response.data || {} }
    } catch (error) {
        const status = error?.response?.status
        const mensagem =
            status === 404
                ? "Link de cadastro não encontrado ou expirado."
                : error?.response?.data?.mensagem || error.message || "Erro ao carregar o rascunho."
        RegistrarLogErro(error, "obterRascunhoOnboarding", { token })
        return { retornoErro: 1, mensagem, status }
    }
}

// Status do onboarding pelo token do link. Se o cadastro já foi concluído, retorna
// os dados do resultado + o status atual da fatura (para exibir "fatura paga"). Público.
export async function obterStatusOnboarding(token) {
    try {
        const response = await api.get(`clientefiel/StatusOnboarding/${encodeURIComponent(token)}`)
        return { retornoErro: 0, data: response.data || {} }
    } catch (error) {
        const status = error?.response?.status
        RegistrarLogErro(error, "obterStatusOnboarding", { token })
        return { retornoErro: 1, status }
    }
}

export async function getCadastroEstabelecimento(idEstabelecimento, basicUsuario) {
    try {
        const response = await api.get(`integracao/estabelecimento/${idEstabelecimento}/cadastro`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: basicUsuario,
            },
        })
        return { retornoErro: 0, data: response.data }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const msgPadrao =
            status === 401 || status === 403
                ? "Sem permissão para editar este estabelecimento."
                : "Não foi possível carregar os dados do estabelecimento."
        const mensagem = data?.mensagem || data?.message || error.message || msgPadrao
        RegistrarLogErro(error, "getCadastroEstabelecimento", { idEstabelecimento })
        return { retornoErro: 1, mensagem, status }
    }
}

export async function salvarCadastroEstabelecimento(idEstabelecimento, body, basicUsuario) {
    try {
        const response = await api.put(
            `integracao/estabelecimento/${idEstabelecimento}/cadastro`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: basicUsuario,
                },
            }
        )
        return { retornoErro: 0, data: response.data }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const msgPadrao =
            status === 400
                ? "Dados inválidos. Verifique os campos e tente novamente."
                : status === 401 || status === 403
                ? "Sem permissão para salvar este estabelecimento."
                : "Não foi possível salvar os dados. Tente novamente."
        const mensagem = data?.mensagem || data?.message || error.message || msgPadrao
        RegistrarLogErro(error, "salvarCadastroEstabelecimento", { idEstabelecimento })
        return { retornoErro: 1, mensagem, status }
    }
}

export async function uploadLogoEstabelecimento(idEstabelecimento, file, tipo, basicUsuario) {
    try {
        const response = await api.post(
            `integracao/estabelecimento/${idEstabelecimento}/cadastro/upload-logo?tipo=${encodeURIComponent(
                tipo
            )}`,
            file,
            {
                headers: {
                    "Content-Type": "application/octet-stream",
                    Authorization: basicUsuario,
                },
            }
        )
        return { retornoErro: 0, url: response.data?.url }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const msgPadrao =
            status === 413
                ? "Arquivo muito grande. Limite: 2MB."
                : "Não foi possível enviar o logo. Tente novamente."
        const mensagem = data?.mensagem || data?.message || error.message || msgPadrao
        RegistrarLogErro(error, "uploadLogoEstabelecimento", { idEstabelecimento, tipo })
        return { retornoErro: 1, mensagem, status }
    }
}

export async function buscarEstabelecimentosPaginado(filtros, basicUsuario) {
    try {
        const params = new URLSearchParams()
        if (filtros.q) params.append("q", filtros.q)
        if (filtros.codigo) params.append("codigo", filtros.codigo)
        if (filtros.apenasAtivos === false) params.append("apenasAtivos", "false")
        params.append("page", String(filtros.page || 1))
        params.append("size", String(filtros.size || 20))

        const response = await api.get(`integracao/estabelecimentos/buscar?${params.toString()}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: basicUsuario,
            },
        })

        return {
            retornoErro: 0,
            estabelecimentos: response.data?.estabelecimentos || [],
            page: response.data?.page ?? filtros.page ?? 1,
            size: response.data?.size ?? filtros.size ?? 20,
            total: response.data?.total ?? 0,
        }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const msgPadrao =
            status === 401 || status === 403
                ? "Sessão inválida ou sem permissão para listar os estabelecimentos."
                : "Não foi possível buscar os estabelecimentos. Tente novamente."
        const mensagem = data?.mensagem || data?.message || error.message || msgPadrao
        RegistrarLogErro(error, "buscarEstabelecimentosPaginado", filtros)
        return {
            retornoErro: 1,
            mensagem,
            status,
            estabelecimentos: [],
            page: 1,
            size: filtros.size || 20,
            total: 0,
        }
    }
}

export async function buscarPedidosListagem(idEstabelecimento, filtros, basicUsuario) {
    try {
        const params = new URLSearchParams()

        const appendIfSet = (key, value) => {
            if (value !== undefined && value !== null && value !== "") {
                params.append(key, value)
            }
        }
        const appendList = (key, list) => {
            ;(list || []).forEach(v => {
                if (v !== undefined && v !== null && v !== "") params.append(key, v)
            })
        }

        appendIfSet("dataInicio", filtros.dataInicio)
        appendIfSet("dataFim", filtros.dataFim)
        appendIfSet("nomeCliente", filtros.nomeCliente)
        appendIfSet("telefone", filtros.telefone)
        appendIfSet("codigoPedido", filtros.codigoPedido)
        appendList("idsFormasPagamento", filtros.idsFormasPagamento)
        appendList("tiposPedido", filtros.tiposPedido)
        appendList("situacoes", filtros.situacoes)
        appendList("plataformas", filtros.plataformas)
        appendList("tiposFormaPagamento", filtros.tiposFormaPagamento)
        appendIfSet("estabelecimentoFiltro", filtros.estabelecimentoFiltro)
        if (filtros.temNotaFiscal === true || filtros.temNotaFiscal === false) {
            params.append("temNotaFiscal", String(filtros.temNotaFiscal))
        }
        appendIfSet("cupomDesconto", filtros.cupomDesconto)
        appendIfSet("campoData", filtros.campoData)
        appendIfSet("page", filtros.page)
        appendIfSet("size", filtros.size)

        const response = await api.get(
            `integracao/estabelecimento/${idEstabelecimento}/pedidos?${params.toString()}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: basicUsuario,
                },
            }
        )

        return {
            retornoErro: 0,
            pedidos: response.data?.pedidos || [],
            page: response.data?.page ?? filtros.page ?? 1,
            size: response.data?.size ?? filtros.size ?? 100,
            total: response.data?.total ?? 0,
        }
    } catch (error) {
        const status = error?.response?.status
        const data = error?.response?.data
        const msgPadrao =
            status === 401 || status === 403
                ? "Sem permissão para acessar os pedidos deste estabelecimento."
                : status === 400
                ? "Filtros inválidos. Verifique o período (máximo de 1 ano) e tente novamente."
                : "Não foi possível buscar os pedidos. Tente novamente."
        const mensagem = data?.mensagem || data?.message || error.message || msgPadrao
        RegistrarLogErro(error, "buscarPedidosListagem", { idEstabelecimento, filtros })
        return { retornoErro: 1, mensagem, status, pedidos: [], page: 1, size: 100, total: 0 }
    }
}

export async function EmitirNotaFiscal(data) {
    try {
        const response = await api.get("notafiscal/obterNota/" + data, {
            headers: { "Content-Type": "application/json" },
        })

        console.warn("EmitirNotaFiscal =>", response)

        return tratamentoResponse(response, "EmitirNotaFiscal")
    } catch (error) {
        RegistrarLogErro(error, "EmitirNotaFiscal", data)
    }
}

export async function getJSONNotaFiscal(data) {
    try {
        const response = await api.get("notafiscal/obterNotaJson/" + data, {
            headers: { "Content-Type": "application/json" },
        })

        console.warn("getJSONNotaFiscal =>", response)

        return tratamentoResponse(response, "JSONNotaFiscal")
    } catch (error) {
        RegistrarLogErro(error, "getJSONNotaFiscal", data)
    }
}

export async function cancelarNotaFiscal(data) {
    try {
        const response = await api.post("notafiscal/cancelarNotaConsumidor/", data, {
            headers: { "Content-Type": "application/json" },
        })

        console.warn("cancelarNotaFiscal =>", response)

        return tratamentoResponse(response, "cancelarNotaConsumidor")
    } catch (error) {
        RegistrarLogErro(error, "cancelarNotaConsumidor", data)
        console.error(error)
    }
}

export async function selecionarMotoqueiroPedido(idPedido, motoqueiroSelecionado, Authorization) {
    try {
        const response = await api.post(
            "integracao/entregadores/selecionar/" + idPedido + "/" + motoqueiroSelecionado,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            }
        )

        console.warn("selecionarMotoqueiroPedido =>", response)

        return tratamentoResponse(response, "selecionarMotoqueiroPedido")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "selecionarMotoqueiroPedido", { idPedido, motoqueiroSelecionado })
    }
}

export async function listarMotoqueirosEstabelecimento(Authorization) {
    try {
        const response = await api.post(
            "integracao/entregadores/listar",
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            }
        )

        console.warn("listarMotoqueirosEstabelecimento =>", response)

        return tratamentoResponse(response, "listarMotoqueirosEstabelecimento")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "listarMotoqueirosEstabelecimento", {})
    }
}

export async function cancelarPedido(
    data,
    pedido,
    Authorization,
    hashInternaClienteFielIfood,
    ativaIntegracaoIfood
) {
    try {
        const response = await api.post(
            `integracao/orders/${pedido.id}/statuses/cancellationRequestedV2`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization,
                    fixed_token_ifood: hashInternaClienteFielIfood,
                    ifood_integration_active: ativaIntegracaoIfood,
                },
            }
        )

        console.warn("cancelarPedido =>", response)

        return tratamentoResponse(response, "cancelarPedido")
    } catch (error) {
        RegistrarLogErro(error, "cancelarPedido", {
            data,
            pedido,
            Authorization,
            hashInternaClienteFielIfood,
            ativaIntegracaoIfood,
        })
    }
}

export const BuscarFormaDePagamentos = async idEstabelecimento => {
    try {
        const response = await api
            .get("integracao/formaspagamento/" + idEstabelecimento, {
                headers: { "Content-Type": "application/json" },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "BuscarFormaDePagamentos")
    } catch (error) {
        RegistrarLogErro(error, "BuscarFormaDePagamentos")
        return { retornoErro: 1, mensagem: error.message }
    }
}

// `imprimir` (default false): escolha do operador ao fechar a mesa. Vai ao BACKEND, que —
// quando true — gera a SolicitacaoImpressao e publica a conta no SSE (kind:"IMPRESSAO"),
// para a comanda de fechamento sair na ESTAÇÃO DA LOJA (não na estação que clicou). Assim o
// garçom pode fechar do celular sem impressora. Dedup por SolicitacaoImpressao.id no painel.
export const FecharMesa = async (data, Authorization, imprimir = false) => {
    try {
        const response = await api
            .post(`integracao/fecharmesa/?imprimir=${imprimir ? "true" : "false"}`, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "FecharMesa")
    } catch (error) {
        RegistrarLogErro(error, "FecharMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Reimprime a comanda de um pedido/rodada de mesa. O backend regenera a
// SolicitacaoImpressao e publica no SSE (kind:"IMPRESSAO"): a via sai na ESTAÇÃO DA LOJA,
// não localmente — assim o garçom reimprime do celular sem impressora. Dedup por
// SolicitacaoImpressao.id no painel.
export const reimprimirComandaMesa = async (idPedido, Authorization) => {
    try {
        const response = await api
            .post(
                `integracao/reimprimircomanda/${idPedido}`,
                {},
                {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                }
            )
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "reimprimirComandaMesa")
    } catch (error) {
        RegistrarLogErro(error, "reimprimirComandaMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const MudarNumeroMesa = async (data, Authorization) => {
    try {
        const response = await api
            .post("integracao/alterarmesa/", data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "MudarNumeroMesa")
    } catch (error) {
        RegistrarLogErro(error, "MudarNumeroMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ExcluirItemDoPedidoMesa = async (idItemPedido, data, Authorization, motivo) => {
    try {
        const url =
            "integracao/excluiritempedido/" +
            idItemPedido +
            (motivo ? "?motivo=" + encodeURIComponent(motivo) : "")

        const response = await api
            .post(url, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "ExlcuirItemDoPedidoMesa")
    } catch (error) {
        RegistrarLogErro(error, "ExlcuirItemDoPedidoMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const EditarPedidoMesa = async (idPedido, data, Authorization, motivo) => {
    try {
        const url =
            "integracao/editaritempedido/" +
            idPedido +
            (motivo ? "?motivo=" + encodeURIComponent(motivo) : "")

        const response = await api
            .post(url, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "EditarPedidoMesa")
    } catch (error) {
        RegistrarLogErro(error, "EditarPedidoMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const inserirItensPedidoMesa = async (idPedido, data, Authorization) => {
    try {
        const response = await api
            .post("integracao/inseriritenspedido/" + idPedido, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "InserirItemPedidoMesa")
    } catch (error) {
        RegistrarLogErro(error, "InserirItemPedidoMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ObterPedidoCompleto = async (idPedido, Authorization) => {
    try {
        const response = await api
            .post(
                "pedido/" + idPedido,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                    },
                }
            )
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("ObterPedidoCompleto => ", response)

        return tratamentoResponse(response, "ObterPedidoCompleto")
    } catch (error) {
        RegistrarLogErro(error, "ObterPedidoCompleto", idPedido)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const EditarPedido = async (data, Authorization) => {
    try {
        const response = await api
            .post("pedido/editar", data, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: Authorization,
                },
            })
            .catch(function (error) {
                const mensagemBack =
                    error?.response?.data?.mensagem ||
                    error?.response?.data?.message ||
                    (typeof error?.response?.data === "string" ? error.response.data : null)
                const resp = mensagemBack || ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("EditarPedido => ", response)

        return tratamentoResponse(response, "EditarPedido")
    } catch (error) {
        RegistrarLogErro(error, "EditarPedido", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// `imprimir` (default false): idem FecharMesa, para o fechamento PARCIAL. Quando true, o
// backend publica o comprovante parcial no SSE para sair na estação da loja.
export const salvarMesaParcial = async (data, Authorization, imprimir = false) => {
    try {
        const response = await api
            .post(`integracao/salvarmesa?imprimir=${imprimir ? "true" : "false"}`, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })


        return tratamentoResponse(response, "salvarMesaParcial")
    } catch (error) {
        RegistrarLogErro(error, "salvarMesaParcial")
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Manda a conta da mesa para o BACKEND imprimir. Quando `imprimir` (default true), ele gera
// a SolicitacaoImpressao e publica a conta no SSE (kind:"IMPRESSAO"), para a comanda sair
// SEMPRE na ESTAÇÃO/COMPUTADOR configurado para impressão — não na estação que clicou. Assim
// o botão "imprimir" da tela de fechamento imprime do computador configurado, e o garçom pode
// disparar do celular sem impressora. Dedup por SolicitacaoImpressao.id no painel. Mesmo corpo
// (a mesa) e mesmo padrão de `?imprimir=` de FecharMesa/salvarMesaParcial.
export const imprimirMesa = async (data, Authorization, imprimir = true) => {
    try {
        const response = await api
            .post(`integracao/imprimirmesa?imprimir=${imprimir ? "true" : "false"}`, data, {
                headers: { "Content-Type": "application/json", Authorization: Authorization },
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        return tratamentoResponse(response, "imprimirMesa")
    } catch (error) {
        RegistrarLogErro(error, "imprimirMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const alterarEstabelecimentoDoPedido = async (
    idPedido,
    idEstabelecimento,
    Authorization
) => {
    const data = { id: idEstabelecimento }
    try {
        const response = await api.post("integracao/alterarestabelecimento/" + idPedido, data, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "AlterarEstabelecimentoDoPedido")
        return { retornoErro: 1, mensagem: error.message }
    }
}

/**
 * Gera uma cobrança Pix (QR Code + copia-e-cola) para um pedido a partir do painel — inclusive
 * pedidos já finalizados/pagos offline. Retorna o StatusPedido com qrCodeText (copia-e-cola),
 * qrCodeUrl (imagem), urlLinkCartao (link de cartão Pagar.me, quando houver) e telefone (já com DDI).
 */
export async function gerarCobrancaPix(idPedido, Authorization) {
    try {
        const response = await api.post(
            `pedido/gerar-cobranca-pix?idPedido=${idPedido}`,
            {},
            { headers: { "Content-Type": "application/json", Authorization: Authorization } }
        )

        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "gerarCobrancaPix")
        const data = error?.response?.data
        const mensagem =
            (data && data.mensagem) || (typeof data === "string" ? data : null) || error.message
        return { retornoErro: 1, mensagem }
    }
}

/**
 * Consulta ativa (bate no gateway) o status de pagamento de uma cobrança Pix gerada pelo painel.
 * Retorna o StatusPedido com statusPagamento atualizado (5 = PAGO). Usado no polling do popup.
 */
export async function obterStatusCobrancaPix(idPedido, Authorization) {
    try {
        const response = await api.get(`pedido/status-cobranca-pix?idPedido=${idPedido}`, {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })

        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "obterStatusCobrancaPix")
        const data = error?.response?.data
        const mensagem =
            (data && data.mensagem) || (typeof data === "string" ? data : null) || error.message
        return { retornoErro: 1, mensagem }
    }
}

export const buscarRedeDeEstabelecimentos = async Authorization => {
    try {
        const response = await api.get("integracao/buscarestabelecimentosdarede", {
            headers: { "Content-Type": "application/json", Authorization: Authorization },
        })


        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "buscarRedeDeEstabelecimentos")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const listarMesasDiario = async (date, mesa, Authorization) => {
    try {
        const url = `integracao/listarmesas?data=${date}${mesa && "&numeroMesa=" + mesa}`
        const headers = { "Content-Type": "application/json", Authorization: Authorization }

        const response = await api.get(url, { headers: headers })

        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "listarMesasDiario")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const detalhesMesa = async (idMesa, Authorization) => {
    try {
        const url = `/integracao/detalhesmesa/${idMesa}`
        const headers = { "Content-Type": "application/json", Authorization: Authorization }

        const response = await api.get(url, { headers: headers })

        if (response.data.codErro > 0)
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
        else if (typeof response.data == "string")
            return {
                retornoErro: 1,
                mensagem: "Erro inesperado, entre em contato com os reponsáveis.",
            }
        else return response.data
    } catch (error) {
        RegistrarLogErro(error, "detalhesMesa")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export async function AceitarPedido(idPedido) {
    try {
        const autorizacao = localStorage.getItem("chaveSistema")

        const response = await api.post(
            `integracao/orders/${idPedido}/statuses/confirmation`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: autorizacao,
                },
            }
        )

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "AceitarPedido", {})
    }
}

export async function PrepararPedido(idPedido) {
    try {
        const autorizacao = localStorage.getItem("chaveSistema")

        const response = await api.post(
            `integracao/orders/${idPedido}/statuses/preparation`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: autorizacao,
                },
            }
        )

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "PrepararPedido", {})
    }
}

export async function DespacharPedido(idPedido) {
    try {
        const autorizacao = localStorage.getItem("chaveSistema")

        const response = await api.post(
            `integracao/orders/${idPedido}/statuses/dispatch`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: autorizacao,
                },
            }
        )

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "DespacharPedido", {})
    }
}

export async function FinalizarPedido(idPedido) {
    try {
        const autorizacao = localStorage.getItem("chaveSistema")

        const response = await api.post(
            `integracao/orders/${idPedido}/statuses/delivery`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: autorizacao,
                },
            }
        )

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "FinalizarPedido", {})
    }
}

export async function CancelarPedido(idPedido, data) {
    try {
        const autorizacao = localStorage.getItem("chaveSistema")
        const { hashInternaClienteFielIfood, ativaIntegracaoIfood } =
            useAppStore.getState().configuracoes.user.parametros

        const response = await api.post(
            `integracao/orders/${idPedido}/statuses/cancellationRequestedV2`,
            data,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: autorizacao,
                    fixed_token_ifood: hashInternaClienteFielIfood,
                    ifood_integration_active: ativaIntegracaoIfood,
                },
            }
        )

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "CancelarPedido", {})
    }
}

export async function reabrirMesa(idMesa) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const data = {}
    try {
        const response = await api.post(`integracao/reabrirmesa/${idMesa}`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: autorizacao,
            },
        })

        return response.data
    } catch (error) {
        RegistrarLogErro(error, "CancelarPedido", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}
